<template lang="pug">
transition(name='slide-bottom')
  .ui-popup(v-if="modelValue" :class="{'profile-info-popup': profileInfo, 'onboarding-popup': onboarding}" @click.self="closePopup")
    .ui-popup__content
      .ui-popup__content-header
        p.title(:class="{chip: isOldProfile}") {{ title }}
        svg(class="flex-[0_0_24px]", xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="$emit('update:modelValue', false)")
          path(d="M18 6L6 18M6 6L18 18" stroke="#39444C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")

      template(v-if="onboarding")
        slot(name="onboarding")

      template(v-else)
        slot(name="main")
        .buttons.pt-2.pb-2.mt-auto.flex.flex-col.gap-2
          slot(name="actions")
</template>
<script>
export default {
  name: 'UiPopup',
  props: {
    title: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    isOldProfile: {
      type: Boolean,
      default: false,
    },
    profileInfo: {
      type: Boolean,
      default: false,
    },
    onboarding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closePopup() {
      this.$emit('update:modelValue', false)
    },
  },
}
</script>
<style lang="scss">
.ui-popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow:
    0px -2px 4px -2px rgba(4, 8, 13, 0.12),
    0px -8px 16px -2px rgba(4, 8, 13, 0.12);
  transition: 0.3s;
  display: flex;
  align-items: flex-end;
  z-index: 2;

  &.profile-info-popup {
    .ui-popup__content-header {
      p {
        color: #333f48;
        font-family: Rubik;
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }

  &__content {
    background: white;
    padding: 16px;
    width: 100%;
    border-radius: 12px 12px 0 0;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 480px) {
      padding: 16px;
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        color: #333f48;
        font-family: Rubik;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;

        &.chip {
          background-color: #faeadf;
          color: #c72866;
          padding: 2px 8px;
          border-radius: 4px;
          align-self: flex-start;
          border: 1px solid rgba(199, 40, 102, 0.1);
          overflow: hidden;
          text-overflow: ellipsis;
          font-family: Rubik;
          font-size: 12px;
          font-weight: 400;
          line-height: 14px;
        }
      }

      svg {
        cursor: pointer;
      }
    }

    &-main {
      display: flex;
      flex-direction: column;
      gap: 4px;

      &-fio {
        color: #333f48;
        font-family: Rubik;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }

      &-location {
        color: #858c91;
        font-family: Rubik;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }

      &-days {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-top: 12px;

        p {
          color: #333f48;
          font-family: Rubik;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
        }

        span {
          color: #7ba354;
          text-align: right;
          font-family: Rubik;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
        }
      }
    }

    &-actions {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  &.onboarding-popup {
    z-index: 5000;
    align-items: center;
    justify-content: center;
    inset: 0;
    position: fixed;

    .ui-popup__content {
      width: auto;
      max-width: 560px;
      border-radius: 16px;
      padding: 24px;
      box-shadow:
        0 8px 24px rgba(4, 8, 13, 0.16),
        0 0 0 1px rgba(0, 0, 0, 0.04);

      &-header {
        align-items: flex-start;
      }

      .title {
        font-weight: 600;
        font-size: 20px;
        line-height: 1.4;
        vertical-align: middle;
      }

      ul {
        li {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 0;
          font-family: Inter;
          font-weight: 400;
          font-size: 14px;
          line-height: 1.4;

          &:not(:last-child) {
            border-bottom: 1px solid #e6e8ea;
          }

          svg {
            min-width: 24px;
          }
        }
      }
    }

    @media (max-width: 560px) {
      align-items: flex-end;
      justify-content: center;

      .ui-popup__content-header .title {
        font-family: Inter;
        font-weight: 500;
        font-size: 18px;
        line-height: 1.3;
        color: #39444c;
      }

      .ui-popup__content {
        width: 100%;
        max-width: 100%;
        margin: 0;
        border-radius: 16px 16px 0 0;
        padding: 16px 16px calc(16px + env(safe-area-inset-bottom));

        ul {
          border-top: 1px solid #e5ecf1;
        }
      }
    }
  }
}
.slide-bottom-enter-from,
.slide-bottom-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
